import { GoodsOfferStatus } from '@/api/v2/requests/goods-offers';
export const GOODS_OFFER_STATUS_COLORS = {
    [GoodsOfferStatus.IN_OFFER]: 'bg-yellow',
    [GoodsOfferStatus.IN_CONTRACT]: 'bg-red',
    [GoodsOfferStatus.IN_RESERVATION]: 'bg-orange',
};
export const GOODS_OFFER_STATUS_DOT_COLORS = {
    [GoodsOfferStatus.IN_OFFER]: '#FFD440',
    [GoodsOfferStatus.IN_RESERVATION]: '#FF7A30',
    [GoodsOfferStatus.IN_CONTRACT]: '#DB0012',
    [GoodsOfferStatus.DRAFT]: '#1C34AA',
};
